(() => {
	angular.module('main').directive('addExtraShootModal', addExtraShootModal);

	addExtraShootModal.$inject = [
		'$rootScope',
		'$location',
		'calendarEventsDataService',
		'extraShootService',
		'messageService',
		'searchService',
		'timeService',
		'workflowService',
		'validationService',
		'settingsService',
		'timeConverter',
		'utilsService'
	];

	function addExtraShootModal(
		$rootScope,
		$location,
		calendarEventsDataService,
		extraShootService,
		messageService,
		searchService,
		timeService,
		workflowService,
		validationService,
		settingsService,
		timeConverter,
		utilsService
	) {
		return {
			restrict: 'E',
			scope: {
				activeJobs: '<',
				jobId: '<',
				taskList: '=',
				updateView: '&'
			},
			template: `<section>
                        <div id="extraShootModal" class="modal modal-center fade modal-appointment-lx" data-backdrop="static"
                             data-keyboard="false" data-autotest-modal="extraShoot">
                            <div class="modal-dialog modal-dialog-datepicker">
                                <form ng-submit="saveExtraShoot()">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <btn-close></btn-close>
                                            <h3 class="modal-title">{{extraShoot.id ? 'Edit extra shoot':'Add extra shoot'}}</h3>
                                        </div>
                                        <div class="modal-body" style="padding-bottom: 7px!important">
                                            <h3 class="mt-0 mb-25">Extra shoot details</h3>
                                            <div class="flex-row flex-wrap-xs">
                                                <div class="form-group  w-min-100 flex-basis-full-xs">
                                                    <label class="control-label">Name</label>
                                                </div>
                                                <div class="form-group w-max-415 flex-with-full">
                                                    <input type="text" autocomplete="off" class="form-control" name="extraShootName" ng-model="extraShoot.name"
                                                           required>
                                                </div>
                                            </div>
                    
                                            <hr class="mt-15">
                                            
                                            <h3 class="mt-30 mb-25">Extra shoot schedule</h3>
                    
                                            <div class="form-group">
                                                 <div class="flex-row flex-wrap-xs">
                                                    <div class="w-min-100 flex-basis-full-xs">
                                                        <label class="control-label">Date</label>
                                                    </div>
                    
                                                    <div class="flex-row flex-wrap-xs flex-with-full w-max-415">
                                                        <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input">
                        
                                                        <input ng-model="extraShoot.startDate" class="form-control"
                                                               type="date" name="input" 
                                                               data-placeholder="{{datapickerDateFormat}}" 
                                                               min="2001-12-31"  max="2999-12-31"
                                                               data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                        </div>
                        
                                                        <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>
                        
                                                        <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input">
                                                            <input ng-model="extraShoot.endDate" class="form-control w-150 flex-with-full"
                                                                   type="date" name="input" 
                                                                   data-placeholder="{{datapickerDateFormat}}" 
                                                                   min="{{( extraShoot.startDate ) ? ( extraShoot.startDate | date : 'yyyy-MM-dd') : (now | date : 'yyyy-MM-dd') }}"
                                                                   max="2999-12-31"
                                                                   data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                        </div>
                                                                 
                                                    </div>
                    
                                                    <div class="mb-15 pt-6 flex-row flex-basis-full-xs" style="padding-left: 20px !important;">
                                                        <div class="checkbox-squared">
                                                            <input type="checkbox" id="checkbox-squared-all-day-shoot"
                                                                   ng-model="extraShoot.allday"/>
                                                            <label for="checkbox-squared-all-day-shoot"></label>
                                                        </div>
                                                        <label for="checkbox-squared-all-day-shoot">All day</label>
                                                    </div>
                                                </div>
                                                
                                                <div class="flex-row flex-wrap-xs">
                                                    <div class="w-min-100 flex-basis-full-xs">
                                                        <label class="control-label">Time</label>
                                                    </div>
                                                    <div class="job-date flex-with-full w-max-415">
                                                        <div class="flex-row flex-wrap-xs flex-basis-full-xs">
                                                            <div class="flex-1 mb-15 flex-with-full">
                                                                <sn-timepicker sn-dr-model="extraShoot.startTime"
                                                                               sn-dr-checked="extraShoot.allday"></sn-timepicker>
                                                            </div>
                                                            <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>
                                                            <div class="flex-1 mb-15 w-150 flex-with-full">
                                                                <sn-timepicker sn-dr-model="extraShoot.endTime"
                                                                               sn-dr-checked="extraShoot.allday"></sn-timepicker>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                    
                                                <div class="flex-row flex-wrap-xs">
                                                    <div class="w-min-100 flex-basis-full-xs">
                                                        <label class="control-label">Location</label>
                                                    </div>
                                                    <input type="text" class="hide hidden form-control"
                                                           ng-model="extraShoot.location"/>
                                                    <div class="mb-15 w-max-415 flex-with-full box-no-transition-small"
                                                         ng-controller="GoogleAutocompleteController">
                                                        <input type="text" id="Autocomplete2" ng-model="autocomplete" placeholder=""
                                                               class="form-control" ng-autocomplete options="options" details="details"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <section ng-hide="isJobView || isLeadView" class="pb-30">
                                                 
                                                <hr class="mb-30">
                                                <h4 class="f-normal">Add this extra shoot to the workflow of an active lead/job</h4>
                        
                                                <div class="flex-row grey-group-field mb-0 mt-30 text-xs-center text-sm-left" style="padding:23px">
                                                <div class="mr-15">
                                                    <h4 class="f-normal">Choose active lead/job</h4>
                                                </div>
                                                <div class="flex-1">
                                                    <input placeholder="Start entering job name" class="form-control" type="text" autocomplete="off"
                                                           typeahead="idName as idName.name for idName in jobNames | filter:$viewValue"
                                                           ng-model="extraShoot.jobSearch">
                                                </div>
                                                </div>
                                            </section>
                                          
                                        </div>
                                        <div class="modal-footer modal-foot">
                                           <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"
                                                        spinning-wheel is-spinning-wheel-active="button_disable"
                                                 >Save extra shoot</button>
                                            <button ng-disabled="button_disable" class="btn btn-lg btn-delete" 
                                                   ng-hide="!extraShoot.id || isJobView || isLeadView" ng-click="showDeleteExtraShoot(extraShoot, $event)" type="button">Delete
                                            </button>
                                            
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                        <delete-extrashoot-modal delete="deleteExtrashoot(deleteId)"></delete-extrashoot-modal>
                    </section>
             `,
			replace: true,
			transclude: true,
			link(scope) {
				scope.isJobView = $location.path().includes('/jobs/view/');
				scope.isLeadView = $location.path().includes('/leads/view/');
				scope.job = {};
				const TIME = '12:00 PM';
				let jobSearchTimer;
				const input = $('input');
				$(document)
					.on('show.bs.modal', '#extraShootModal', () => {
						scope.taskInfo = workflowService.getTaskInfo();
						settingsService.timeFormatSettings.subscribe(data => {
							if (data.timeFormat !== null) {
								scope.timeFormatIs12HorsFormat = data.timeFormat === 'T_12';
							}
						});
						$('#extraShootModal')
							.find('input.ws-date')
							.prop('autocomplete', 'off');

						settingsService.timeFormatSettings.subscribe(data => {
							scope.dataFormatMonth = data.dateFormat;
						});

						scope.datapickerDateFormat =
							scope.dataFormatMonth === 'DD_MM_YYYY'
								? 'dd/mm/yyyy'
								: 'mm/dd/yyyy';

						scope.extraShoot = angular.copy(scope.taskInfo.task);
						scope.job.location = angular.copy(scope.extraShoot.location);

						if (scope.extraShoot.startDate) {
							convertDateTime();
						} else {
							scope.extraShoot.startTime = null;
						}

						scope.now = new Date();
						scope.now.setHours(0, 0, 0, 0);
						scope.jobNames = [];
						scope.$evalAsync();
					})
					.on('shown.bs.modal', '#extraShootModal', function() {
						$(this)
							.find('input')
							.first()
							.focus();

						validationService.isModalClosePrevented(input);
					})
					.on('hide.bs.modal', '#extraShootModal', () => {
						scope.extraShoot.startTime = undefined;
					});

				scope.$watch('extraShoot.startDate', checkExtraShootDate);
				scope.$watch('extraShoot.startTime', checkExtraShootTime);

				scope.$watch('extraShoot.allday', setTimeAfterAllDay);

				scope.$watch('extraShoot.location', setLocation);

				// delete extraShoot

				scope.showDeleteExtraShoot = function(extraShoot, event) {
					scope.deleteId = extraShoot.id;
					scope.deleteExtraShootName = extraShoot.name;
					utilsService.showNextModal(
						'#extraShootModal',
						'#deleteExtrashootModal',
						event
					);
				};

				scope.deleteExtrashoot = function(id) {
					$('#deleteExtrashootModal').modal('hide');

					scope.button_disable = true;

					calendarEventsDataService
						.deleteEvent(id)
						.finally(() => (scope.button_disable = false))
						.subscribe(
							data => successDeleteExtrashoot(data),
							error => messageService.showDefaultErrorMessage(error)
						);
				};

				function successDeleteExtrashoot(data) {
					if (data && data.errorMessage) {
						messageService.showToaster('e_2', 'general', data.errorMessage);
					} else {
						$('#extraShootModal').modal('hide');

						scope.updateView({ resetPagination: true });
						messageService.showToaster(
							's_0',
							'extrashoot',
							scope.deleteExtraShootName
						);
					}
				}

				function setTimeAfterAllDay(newValue, oldValue) {
					if (!newValue && oldValue && !scope.timeFormatIs12HorsFormat) {
						scope.extraShoot.startTime = timeConverter.convert12to24(TIME);
					} else if (!newValue && oldValue && scope.timeFormatIs12HorsFormat) {
						scope.extraShoot.startTime = TIME;
					} else if (newValue && !oldValue) {
						scope.extraShoot.startTime = null;
						scope.extraShoot.endTime = null;
					}
				}

				function checkExtraShootTime(newValue, oldValue) {
					if (
						scope.extraShoot &&
						typeof oldValue !== 'undefined' &&
						newValue &&
						newValue !== oldValue
					) {
						scope.extraShoot.endTime = timeService.setEndTime(newValue);
					}
				}

				function checkExtraShootDate(startDate) {
					if (scope.extraShoot && startDate) {
						if (
							!scope.extraShoot.endDate ||
							startDate > scope.extraShoot.endDate
						) {
							scope.extraShoot.endDate = startDate;
						}
					}
				}

				function setLocation(currentLocation) {
					scope.job.location = currentLocation;
				}

				function convertDateTime() {
					scope.extraShoot = timeService.convertDateTimeForPicker(
						scope.extraShoot,
						'startDate',
						'endDate',
						'startTime',
						'endTime'
					);
				}

				// job search

				scope.$watch('extraShoot.jobSearch', (newValue, oldValue) => {
					if (newValue == null) {
						return;
					}
					if (oldValue == newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (jobSearchTimer != null) {
							clearTimeout(jobSearchTimer);
						}
						jobSearchTimer = setTimeout(
							findAllMatchingJobsNames(newValue),
							500
						);
					} else {
						clearTimeout(jobSearchTimer);
					}
				});

				function findAllMatchingJobsNames(search) {
					if (scope.activeJobs && scope.activeJobs.length) {
						scope.jobNames = searchService.findMatchingNames(
							scope.activeJobs,
							search
						);
					}
				}

				// save extraShoot

				scope.saveExtraShoot = function() {
					let dataToSave = angular.copy(scope.extraShoot);

					scope.button_disable = true;
					if (scope.isJobView === false) {
						scope.isJobView = scope.isLeadView;
					}
					dataToSave = extraShootService.prepareExtraShootToSave(
						dataToSave,
						scope.isJobView,
						scope.job.location
					);

					if (!dataToSave) {
						scope.button_disable = false;
						return false;
					}
					if (scope.isJobView || scope.isLeadView) {
						saveExtraShootAsJobTask(dataToSave);
					} else {
						saveExtraShootAsCalendarEvent(dataToSave);
					}
				};

				function saveExtraShootAsCalendarEvent(dataToSave) {
					const action = dataToSave.id
						? calendarEventsDataService.updateEvent(dataToSave)
						: calendarEventsDataService.createEvent(dataToSave);

					action
						.finally(() => (scope.button_disable = false))
						.subscribe(
							data =>
								successSaveExtraShoot(
									data,
									scope.extraShoot.id,
									scope.extraShoot.jobId
								),
							error => messageService.showDefaultErrorMessage(error)
						);
				}

				function saveExtraShootAsJobTask(dataToSave) {
					if (scope.isJobView) {
						workflowService
							.saveTask(dataToSave, scope.jobId, scope.taskList)
							.finally(() => (scope.button_disable = false))
							.subscribe(
								result =>
									successSaveExtraShootAsTask(result, scope.extraShoot.id),
								error => messageService.showDefaultErrorMessage(error)
							);
					} else {
						workflowService
							.saveTask(dataToSave, dataToSave.leadId, scope.taskList)
							.finally(() => (scope.button_disable = false))
							.subscribe(
								result =>
									successSaveExtraShootAsTask(result, scope.extraShoot.id),
								error => messageService.showDefaultErrorMessage(error)
							);
					}
				}

				function successSaveExtraShootAsTask(data, id) {
					if (!data || !data.tasks) {
						return;
					}

					scope.updateView({ tasks: data.tasks });

					const newTask = `.task-${data.taskToAnimate}`;
					const isEdited = id !== null && id !== undefined;

					isEdited
						? messageService.showToaster('s_4', 'workflow')
						: messageService.showToaster('s_3', 'workflow');

					$('#extraShootModal')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							if (!isEdited) {
								$rootScope.$broadcast('animateTask', newTask);
							}
							$(this).off('hidden.bs.modal');
						});
				}

				function successSaveExtraShoot(data, extraShootId, oldJobId) {
					scope.button_disable = false;
					scope.isUpdateSpinnningWheelActive = false;

					$('#extraShootModal').modal('hide');

					const messageCode = extraShootId ? 's_2' : 's_1';
					messageService.showToaster(messageCode, 'extrashoot');

					const { jobId, taskId, inLead } = data;
					if (
						(taskId && !extraShootId) ||
						(extraShootId && jobId !== oldJobId)
					) {
						$location.search('task', taskId).replace();
						if (inLead === true) {
							$location.path(`/leads/view/${data.leadId}`);
						} else {
							$location.path(`/jobs/view/${jobId}`);
						}
					} else {
						scope.updateView({ resetPagination: false });
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addExtraShootModal.js